// src/pages/NotFound.js (YENİ)
import React from "react";

export default function NotFound() {
  return (
    <section className="section">
      <div className="container">
        <header className="section-head">
          <h1 className="page-title">Sayfa Bulunamadı</h1>
          <p className="page-subtitle">Aradığınız sayfa taşınmış veya silinmiş olabilir.</p>
        </header>

        <div className="notfound-card">
          <p>Menüden bir sayfa seçebilir veya ana sayfaya dönebilirsiniz.</p>
          <div className="notfound-actions">
            <a className="btn primary" href="/">Ana Sayfa</a>
            <a className="btn ghost" href="/contact">İletişim</a>
          </div>
        </div>
      </div>
    </section>
  );
}